import { create } from 'zustand';
import { IPractice } from '../model';

interface IPracticeDetailsState {
  practice: IPractice | null;
  setPractice: (practice: IPractice) => void;
}

export const practiceDetailStore = create<IPracticeDetailsState>((set) => ({
  practice: null,
  setPractice: (practice: IPractice) => set({ practice }),
}));
